import { Component, OnInit, ViewChild, Pipe, PipeTransform } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { LookupService } from "app/webservice/lookup.service";
import { AccountService } from "app/account/account.service";
import { MediaService } from "app/media/media.service"
import { Http, Response, Headers, RequestOptionsArgs } from '@angular/http';
import { CustomData } from 'app/media-search/custom.service';
import { ToastsManager } from "ng2-toastr";
import { ModalDirective } from "ngx-bootstrap";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { GridMetadataService } from "../clearwave-grid/grid.metadata.service";
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';


@Pipe({name: "alphabeticalSort"})
export class AlphabeticalSortPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    array.sort((a: any, b: any) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}

@Component({
  selector: 'app-media-search',
  templateUrl: './media-search.component.html',
  styleUrls: ['./media-search.component.css']
})

export class MediaSearchComponent implements OnInit {

  public serviceStackUrl;
  public media = {
    Speaker_Artist_Author: '',
    Title:'',
    AssetType:'',
    IdNumber: '',
    Topics: [],
    lkpAssetTypeOidList: []
  };

  @ViewChild('scannerInput') scannerInput;
  @ViewChild('checkOutModal') checkOutModal;
  @ViewChild('assetDetailModal') public assetDetailModal: ModalDirective;
  @ViewChild('assetDeleteModal') public assetDeleteModal: ModalDirective;

  public loggedIn: boolean = false;
  public submitted = false;

  public results = [];
  public numResults;
  public topics = [];
  public assetTypes = [];
  public selectedAsset = [];
  public selectedRows = [];
  public confirmDelete = '';

  public customData: CustomData;
  private referenceResults: any[];
  private selected: any[] = null;
  private selectedBook: string = null;
  private selectedBookChapters: any[] = null;
  private reference;
  public lookupsLength: string = '';
  public searching: boolean = false;
  public modalTitle: string = '';
  public modalCallNumber: string = '';
  public MediaSearchResults;

  topicOptionsModel: number[];
  topicOptions: IMultiSelectOption[];

  // Settings configuration
  topicSearchSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true
  };

  // Text configuration
  topicSearchTexts: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Find',
    searchEmptyResult: 'Nothing found...',
    searchNoRenderText: 'Type in search box to see results...',
    defaultTitle: 'Select',
    allSelected: 'All selected',
  };

  constructor(
    private _restService: RestService,
    private _accountService: AccountService,
    private _lookup: LookupService,
    private _mediaService: MediaService,
    private http: Http,
    private _toast: ToastsManager,
    private _router: Router,
    private _gridMetadataService: GridMetadataService,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this.lookupsLength = JSON.parse(localStorage.getItem("lookups"));
    if (!this.lookupsLength || !this.lookupsLength.length) {
      this.getLookups();
    } else {
      this.topics = this._lookup.findLookupByLookupName('Topic');
      this.getTopicOptions();
      this.assetTypes = this._lookup.findLookupByLookupName('AssetType');
      for (var i = this.assetTypes.length - 1; i >= 0; i--) {
        if (this.assetTypes[i].Value === "Video") {
          this.assetTypes[i].Value = 'DVD';
        }
        if (this.assetTypes[i].Value === "Audio") {
          this.assetTypes.splice(i, 1);
        }
      }
    }

    this.customData = new CustomData(http, _accountService, platformLocation);

    if (this._accountService.authToken.value !== "") {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }

    this.MediaSearchResults = this._gridMetadataService.describe('MediaSearchResults', null);
    this.MediaSearchResults.forceFitColumns = true;
    this.MediaSearchResults.height = -475;
    this.MediaSearchResults.completeGridEditDisabled = true;
    this.MediaSearchResults.disableRest = true;
    this.MediaSearchResults.onDblClick = this.openModal.bind(this);
    this.MediaSearchResults.onSelectedRowsChanged = this.setSelectedRows.bind(this);
  }

  ngOnInit() {
    
  }

  clearAll() {
    this.media = {
      Speaker_Artist_Author: '',
      Title:'',
      AssetType:'',
      IdNumber: '',
      Topics: [],
      lkpAssetTypeOidList: []
    };

    this.topicOptionsModel = [];
    for (var i = this.assetTypes.length - 1; i >= 0; i--) {
      this.assetTypes[i].checked = false;
    }
  }

  getTopicOptions() {
    for (let topic of this.topics) {
      topic.id = topic.Oid;
      topic.name = topic.Value; 
    }
    this.topicOptions = this.topics.sort((a, b) => a.name.localeCompare(b.name));
  }

  onChange() {
    console.log(this.topicOptionsModel);
  }

  getLookups() {
    let url = this.serviceStackUrl + "CCLibrary-GetLookups";
    this._restService.post(url).then(response => {
      this._lookup.lookups.next(response.Lookups);
      this.topics = this._lookup.findLookupByLookupName('Topic');
      this.getTopicOptions();
      this.assetTypes = this._lookup.findLookupByLookupName('AssetType');
      for (var i = this.assetTypes.length - 1; i >= 0; i--) {
        if (this.assetTypes[i].Value === "Video") {
          this.assetTypes[i].Value = 'DVD';
        }
        if (this.assetTypes[i].Value === "Audio") {
          this.assetTypes.splice(i, 1);
        }
      }
    })
  }

  checkProperties(obj) {
    for (var key in obj) {
      if (obj[key] !== null && obj[key] != "" && obj[key] !== false && obj[key] !== [])
          return false;
    }
    return true;
  }

  searchMedia() {
    this.searching = true;
    
    let url = this.serviceStackUrl + "Asset-GetAssetsByQuery";
    
    this.media.Topics = [];
    if (this.topicOptionsModel && this.topicOptionsModel.length) {
      for (let option of this.topicOptionsModel) {
        this.media.Topics.push({TopicOid: option, TopicName: ''});
      }
    }
    if (this.media.Title.length) {
      this.media.Title = "*" + this.media.Title + "*";
    }
    if (this.media.Speaker_Artist_Author.length) {
      this.media.Speaker_Artist_Author = "*" + this.media.Speaker_Artist_Author + "*";
    }
    
    this._restService.post(url, {Query: this.media}).then(response => {
      this.media.Title = this.media.Title.substr(1).slice(0, -1);
      this.media.Speaker_Artist_Author = this.media.Speaker_Artist_Author.substr(1).slice(0, -1);
      this.searching = false;
      this.results = response.Data;
      console.log(this.results);
      this.submitted = true
      
      if (this.submitted && this.results && this.results.length) {
        for (var i = this.results.length - 1; i >= 0; i--) {
          if (this.results[i].AssetType === "Video") {
            this.results[i].AssetType = 'DVD';
          }
          if (this.results[i].AssetType === "Audio") {
            this.results.splice(i, 1);
          }
        }

        this.numResults = this.results.length;
        this.MediaSearchResults.data = this.results;
        this.MediaSearchResults.title = this.numResults + ' Result(s)';
        if (typeof this.MediaSearchResults.setData === "function") {
          this.MediaSearchResults.setData(this.results);
        }
      }
    })
  }

  setSelectedRows(e, args) {
    this.selectedRows = [];
    for (let row of args.rows) {
      this.selectedRows.push(args.grid.getDataItem(row).Oid);
    }
  }
  
  deleteMedia() {
    console.log("delete");
    if (this.selectedRows.length) {
      this.assetDeleteModal.show();
    }
  }

  confirmDeleteMedia() {
    let url = this.serviceStackUrl + "Asset-DeleteAsset";
    if (this.confirmDelete === 'DELETE') {
      console.log("confirm delete");
      this._restService.post(url, { AssetOidList: this.selectedRows }).then(response => {
        this.assetDeleteModal.hide();
        if (response.Success) {
          this._toast.success(this.selectedRows.length + ' item(s) deleted successfully');
          this.selectedRows = [];
          this.confirmDelete = '';
          this.searchMedia();
        }
      });
    }
  }

  /*errorCheckScriptureReference(e) {
    if (e.key === 'Enter') {
      this.searchMedia();
      return;
    }
    if (!this.media.RelatedScripture.length) {
      this.selected = null;
      this.selectedBook = null;
      this.selectedBookChapters = null;
    } else {
      let isInvalidChar = /^[a-zA-Z0-9 :\-\b]+$/;
      if (!isInvalidChar.test(this.media.RelatedScripture)) {
        this._toast.error('Invalid Character.', null, {toastLife: 1500});
      } else {
        let isAlpha = /^[a-zA-Z\s]*$/;
        let isInt = /^[0-9]+$/;
        if (isInt.test(e.key) && this.selectedBook) {
          if (this.media.RelatedScripture.includes(":")) {
            if (this.media.RelatedScripture.includes("-")) {
              let ref = this.media.RelatedScripture.replace(this.selectedBook, "");
              let getVerse = this.media.RelatedScripture.substring(0, this.media.RelatedScripture.indexOf('-')+1);
              let verse = this.media.RelatedScripture.replace(getVerse, "");
              let chapter = ref.substring(0, ref.indexOf(':'));
              if (parseInt(verse) > this.selectedBookChapters[parseInt(chapter)-1]) {
                this._toast.error(this.selectedBook + ' ' + chapter + ' has ' + this.selectedBookChapters[parseInt(chapter)-1] + ' verses.');
              }
            } else {
              let ref = this.media.RelatedScripture.replace(this.selectedBook, "");
              let getVerse = ref.substring(0, ref.indexOf(':')+1);
              let verse = ref.replace(getVerse, "");
              let chapter = ref.substring(0, ref.indexOf(':'));
              if (parseInt(verse) > this.selectedBookChapters[parseInt(chapter)-1]) {
                this._toast.error(this.selectedBook + ' ' + chapter + ' has ' + this.selectedBookChapters[parseInt(chapter)-1] + ' verses.');
              }
            }
          } else {
            if (this.media.RelatedScripture.includes("-")) {
              let beginChapter = this.media.RelatedScripture.replace(this.selectedBook, "");
              let getEndChapter = this.media.RelatedScripture.substring(0, this.media.RelatedScripture.indexOf('-')+1);
              let endChapter = this.media.RelatedScripture.replace(getEndChapter, "");
              if (parseInt(endChapter) > this.selectedBookChapters.length) {
                this._toast.error(this.selectedBook + ' has ' + this.selectedBookChapters.length + ' chapters.');
              }
              if (parseInt(endChapter) < parseInt(beginChapter)) {
                this._toast.error('Beginning chapter must come before end chapter in range.');
              }
            } else {
              let chapter = this.media.RelatedScripture.replace(this.selectedBook, "");
              if (parseInt(chapter) > this.selectedBookChapters.length) {
                this._toast.error(this.selectedBook + ' has ' + this.selectedBookChapters.length + ' chapters.');
              }
            }
          }
        } else if (isInt.test(e.key) && e.code != "Backspace" && !this.selectedBook && this.media.RelatedScripture.charAt(e.key)) {
          this._toast.error('No book selected.');
        }
      }
    }
  }*/

  /*getReferenceResults() {
    let selected = this.media.RelatedScripture;
    if (selected) {
      setTimeout((reference = selected) => {
        this.referenceResults = JSON.parse(localStorage.getItem('scriptureResults'));
        let found = this.referenceResults.filter((result) => {
          return (result.Name == reference);
        });
        if (found[0]) {
          if (found[0].Name) {
            this.selected = found[0];
            this.selectedBook = found[0].Name;
            this.selectedBookChapters = found[0].Verses;
          }
        }
      }, 100);
    }
  }*/

  padDigits(int) {
    if (int.replace(" ", "").length == 1) {
      return "00";
    } else if (int.replace(" ", "").length == 2) {
      return "0";
    }
  }

  /*validate(RelatedScripture) {
    if (RelatedScripture.includes(":")) {
      if (RelatedScripture.includes("-")) {
        let ref = RelatedScripture.replace(this.selectedBook, "");
        let beingVerse = ref.substring(ref.lastIndexOf(":")+1,ref.lastIndexOf("-"));
        let getVerse = RelatedScripture.substring(0, RelatedScripture.indexOf('-')+1);
        let endVerse = RelatedScripture.replace(getVerse, "");
        let chapter = ref.substring(0, ref.indexOf(':'));
        if (parseInt(endVerse) > this.selectedBookChapters[parseInt(chapter)-1]) {
          this.reference = false;
        }
        let from = parseInt(this.selected['BookNumber']+this.padDigits(chapter)+parseInt(chapter)+this.padDigits(beingVerse)+parseInt(beingVerse));
        let to = parseInt(this.selected['BookNumber']+this.padDigits(chapter)+parseInt(chapter)+this.padDigits(endVerse)+parseInt(endVerse));
        this.reference = {FromReference: from, ToReference: to};
      } else {
        let ref = RelatedScripture.replace(this.selectedBook, "");
        let getVerse = ref.substring(0, ref.indexOf(':')+1);
        let verse = ref.replace(getVerse, "");
        let chapter = ref.substring(0, ref.indexOf(':'));
        if (parseInt(verse) > this.selectedBookChapters[parseInt(chapter)-1]) {
          this.reference = false;
        }
        let from = parseInt(this.selected['BookNumber']+this.padDigits(chapter)+parseInt(chapter)+this.padDigits(verse)+parseInt(verse));
        let to = parseInt(this.selected['BookNumber']+this.padDigits(chapter)+parseInt(chapter)+this.padDigits(verse)+parseInt(verse));
        this.reference = {FromReference: from, ToReference: to};
      }
    } else {
      if (RelatedScripture.includes("-")) {
        let ref = RelatedScripture.replace(this.selectedBook, "");
        let beginChapter = ref.replace(" ", "").charAt(0);
        let getEndChapter = RelatedScripture.substring(0, RelatedScripture.indexOf('-')+1);
        let endChapter = RelatedScripture.replace(getEndChapter, "");
        if (parseInt(endChapter) > this.selectedBookChapters.length) {
          this.reference = false;
        }
        if (parseInt(endChapter) < parseInt(beginChapter)) {
          this.reference = false;
        }
        let from = parseInt(this.selected['BookNumber']+this.padDigits(beginChapter)+parseInt(beginChapter)+"000");
        let to = parseInt(this.selected['BookNumber']+this.padDigits(endChapter)+parseInt(endChapter)+"999");
        this.reference = {FromReference: from, ToReference: to};
      } else {
        let chapter = RelatedScripture.replace(this.selectedBook, "");
        if (parseInt(chapter)) {
          if (parseInt(chapter) > this.selectedBookChapters.length) {
            this.reference = false;
          }
          let from = parseInt(this.selected['BookNumber']+this.padDigits(chapter)+parseInt(chapter)+"000");
          let to = parseInt(this.selected['BookNumber']+this.padDigits(chapter)+parseInt(chapter)+"999");
          this.reference = {FromReference: from, ToReference: to};
        } else {
          let from = parseInt(this.selected['BookNumber']+"000"+"000");
          let to = parseInt(this.selected['BookNumber']+"999"+"999");
          this.reference = {FromReference: from, ToReference: to};
        }
      }
    }
  }*/

  /*validateScriptureReference() {
    let isInvalidChar = /^[a-zA-Z0-9 :\-\b]+$/;
    if (!this.media.RelatedScripture || !isInvalidChar.test(this.media.RelatedScripture)) {
      this.reference = false;
    } else {
        if (!this.selected) {
          let beginningChar = this.media.RelatedScripture.substr(0, this.media.RelatedScripture.indexOf(' '));
          let related = this.media.RelatedScripture;

          this._restService.get(environment.SERVICE_STACK_URL + "/Asset-GetScriptureReference?reference=" + beginningChar + ",contains").then(response => {
            if (response.Success && response.References.length === 1) {
              this.selected = response.References[0];
              this.selectedBook = response.References[0].Name;
              this.selectedBookChapters = response.References[0].Verses;
              this.validate(related);
              if (this.reference) {
                this.media.FromReference = this.reference['FromReference'];
                this.media.ToReference = this.reference['ToReference'];
                let url = environment.SERVICE_STACK_URL + "/Asset-GetAssetsByQuery";
                console.log(this.media);
                this._restService.post(url, {Query:this.media}).then(response => {
                  console.log(this.results);
                  this.results = response.Data;
                  this.numResults = this.results.length;
                  this.submitted = true
                })
              } else {
                this.media.FromReference = null;
                this.media.ToReference = null;
                this.media.RelatedScripture = null;
              }
            } else {
              this.reference = false;
            }
          })
        } else {
          this.validate(this.media.RelatedScripture);
          if (this.reference) {
            this.media.FromReference = this.reference['FromReference'];
            this.media.ToReference = this.reference['ToReference'];
            let url = environment.SERVICE_STACK_URL + "/Asset-GetAssetsByQuery";
            console.log(this.media);
            this._restService.post(url, {Query:this.media}).then(response => {
              console.log(this.results);
              this.results = response.Data;
              this.numResults = this.results.length;
              this.submitted = true
            })
          } else {
            this.media.FromReference = null;
            this.media.ToReference = null;
            this.media.RelatedScripture = null;
          }
        }

    }
  }*/

  selectAsset(oid) {
    if (this.media.lkpAssetTypeOidList.indexOf(oid) > -1) {
      this.media.lkpAssetTypeOidList.splice(this.media.lkpAssetTypeOidList.indexOf(oid), 1);
    } else {
      this.media.lkpAssetTypeOidList.push(oid);
    }
  }

  openModal(e, args, row) {
    this.modalTitle = row.Title;
    this.modalCallNumber = row.IdNumber;
    this._mediaService.selectedAsset.next(row);
    this.assetDetailModal.show();
  }

  editMedia(asset) {
    this.assetDetailModal.hide();
    this._router.navigate(['/media/' + this._mediaService.selectedAsset.getValue().Oid]);
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/media-search/media-search.component.ts